import * as React from "react";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Header from "./components/Header/Header";
import { MainContainer } from "./Layout.Styled";
import { theme } from "../themes/theme";

const Layout: React.FC<{ children: any }> = ({ children }) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ margin: 0, padding: 0 }}>
          <Header />
          <MainContainer>
            <Box>{children}</Box>
          </MainContainer>
        </Box>
      </ThemeProvider>
    </>
  );
};

export default Layout;
